import {createFileRoute} from '@tanstack/react-router';
import {createPaymentOrderGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PaymentOrderCreate from '@/practitioner/views/payments/PaymentOrderCreate';

export const Route = createFileRoute('/(practitioner)/practitioner/patient-payment-orders/create')({
  component: PaymentOrderCreate,
  beforeLoad: grantUser(createPaymentOrderGranted)
});
